/* eslint-disable */
import { Component } from 'react';
import { getAllCobrancas, getAllFilteredCobrancas, postLote, deleteCobranca } from '@store/actions';
import { Table, Menu, Icon, Checkbox, Button, Grid, Modal, Header } from 'semantic-ui-react'
import CemigModal from '../shared/cemigModal';
import { connect } from 'react-redux';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import _ from 'lodash';
import m from '@utils/strings';
import ReactToPrint from "react-to-print";
import AjaxLoader from '../shared/ajax_loader';

const INITIAL_STATE = {
    tableRows: [],
    column: null,
    direction: null,
    data: [],
    actualPage: 1,
    amountPages: 1,
    amountGuiasSelecionadas: 0,
    lastRequestWasFiltered: false,
    lastParamsValues: {},
    openSuccessModal: false,
    openErrorModal: false,
    openExcluirModal: false,
    modalValues: null,
    idCobrancaToDelete: null,
    showLoader: false,
    checkAll: false
}

class TableCobrancas extends Component {

    constructor(props) {
        super(props);

        this.state = {
            ...INITIAL_STATE
        }

        this.checkboxesReferences = {};
        this.guiasSelecionadas = [];
    }

    componentDidMount() {
        this.props.updateTableRows(this.updateTableRows);
        this.props.applyFilterTable(this.applyFilterTable);
        this.props.updateApplyingFilter(this.updateApplyingFilter);
        this.props.resetGuiasSelecionadas(this.resetGuiasSelecionadas);
    }

    mapTableRowJSX = (list) => {
        return list.map(
            (cobranca) => {
                let date = cobranca.DataAtendimento.split('-');
                let day = date[2].split('T')[0];
                let month = date[1];
                let year = date[0];

                return (
                    <Table.Row key={cobranca.Id}>
                        <Table.Cell>
                            <div className='td-cobranca-checkbox'>
                                <Checkbox
                                    className='custom-checkbox'
                                    id={`check${cobranca.Id}`}
                                    ref={(check) => this.checkboxesReferences[`check${cobranca.Id}`] = check}
                                    onClick={() => {

                                        if((this.guiasSelecionadas ?? []).findIndex(f => f.Id === cobranca.Id) >= 0)
                                            this.guiasSelecionadas = this.guiasSelecionadas.filter(m =>
                                                m.Id !== cobranca.Id
                                            );
                                        else
                                            this.guiasSelecionadas.push(cobranca);

                                        this.setState({
                                            amountGuiasSelecionadas: (this.guiasSelecionadas ?? []).length,
                                            checkAll: document.querySelectorAll('input[id*=check]').length === this.guiasSelecionadas.length
                                        });
                                    }}
                                />
                            </div>
                        </Table.Cell>
                        <Table.Cell>
                            <div className='td-cobranca-left-align'>
                                {cobranca.NumeroGuiaPrestador}
                            </div>
                        </Table.Cell>
                        <Table.Cell>
                            <div className='td-cobranca-left-align'>
                                {cobranca.NumeroCarteiraBeneficiario}
                            </div>
                        </Table.Cell>
                        <Table.Cell>
                            <div className='td-cobranca-left-align'>
                                {cobranca.NomeBeneficiario}
                            </div>
                        </Table.Cell>
                        <Table.Cell>
                            <div className='td-cobranca-left-align'>
                                {`${day}/${month}/${year}`}
                            </div>
                        </Table.Cell>
                        <Table.Cell>
                            <div className='td-cobranca-left-align'>
                                {cobranca.TipoGuia}
                            </div>
                        </Table.Cell>
                        <Table.Cell>
                            <div className='td-cobranca-center-align'>
                                <img className='cursor-pointer' src="../images/x.png" alt="EXCLUIR" onClick={() => {
                                    this.setState({ openExcluirModal: true, idCobrancaToDelete: cobranca.Id });
                                }} />
                            </div>
                        </Table.Cell>
                    </Table.Row>
                );
            }
        );
    }

    loadTableRows = (willFilter, params) => {

        let mapSuccessFunction = (result) => {
            if (_.isEmpty(result.data) || _.isEmpty(result.data && result.data.ListaCobrancas))
                this.props.callSnackbar(m.TELA_GERACAO_LOTE_COBRANCA.NOTIFICACAO_SUCESSO_RETORNO_VAZIO, 'success');
            let tableRows = this.mapTableRowJSX(result && result.data ? result.data.ListaCobrancas : []);
            this.setState({ tableRows: tableRows, data: result && result.data ? result.data.ListaCobrancas : [] });
            this.setState({ amountPages: result && result.data ? result.data.QuantidadePaginas : 1 });
        }

        let mapErrorFunction = (error) => {
            this.props.callSnackbar(m.TELA_GERACAO_LOTE_COBRANCA.NOTIFICACAO_ERRO_SERVIDOR, 'error')
        }

        let getGuiasForPage = this.state.actualPage;

        if (willFilter) {
            params.filtrarAPartirDe = getGuiasForPage;
            params.idPrestador = this.props.prestador.Id;
            this.props.getAllFilteredCobrancas(params, mapSuccessFunction, mapErrorFunction);
        }
        else {
            this.props.getAllCobrancas(getGuiasForPage, this.props.prestador.Id, mapSuccessFunction, mapErrorFunction);
        }

    }

    applyFilterTable = (params) => {
        this.setState({ actualPage: 1 }, () => {
            if (params)
                this.updateApplyingFilter(params);
            else
                this.updateTableRows();
        });
    }

    updateApplyingFilter = (params) => {
        this.setState({ lastRequestWasFiltered: true });
        if (params) {
            this.setState({ lastParamsValues: params });
            this.loadTableRows(true, params);
        } else if (!_.isEmpty(this.state.lastParamsValues)) {
            this.loadTableRows(true, this.state.lastParamsValues);
        }
    }

    updateTableRows = () => {
        this.setState({ lastRequestWasFiltered: false });
        this.loadTableRows(false);
    }

    enviarLote = () => {
        const { prestador } = this.props;

        if (prestador) {
            this.setState({ showLoader: true });
            let params = {};
            params.nomePrestador = prestador.Nome;
            params.cnesPrestador = prestador.Cnes;
            params.cpfCnpjPrestador = prestador.CPF_CNPJ;
            params.dataTransacao = new Date();
            params.horaTransacao = new Date();

            let listaIdCobranca = [];
            this.guiasSelecionadas.forEach(guia => {
                listaIdCobranca.push(guia.Id);
            });

            params.listaIdCobranca = listaIdCobranca;

            this.props.postLote(
                params,
                result => {
                    this.setState({
                        modalValues: {
                            numeroProtocolo: result.data.NumeroProtocolo,
                            numeroLote: result.data.NumeroLote,
                            data: result.data.DataEnvio,
                            valor: result.data.ValorTotal,
                            codigoGlosa: result.data.CodigoGlosa,
                            motivoGlosa: result.data.MotivoGlosa,
                        },
                        showLoader: !this.state.showLoader,
                    });
                    if (result.data.CodigoGlosa)
                        this.setState({ openErrorModal: true });
                    else
                        this.setState({ openSuccessModal: true });
                    this.props.changeModalOpenedStatus();
                },
                error => {
                    this.setState({ showLoader: !this.state.showLoader });
                    this.props.callSnackbar(m.TELA_GERACAO_LOTE_COBRANCA.NOTIFICACAO_ERRO_SERVIDOR, 'error')
                }
            );
        }
    }

    resetGuiasSelecionadas = () => {

        this.setState({
            ...INITIAL_STATE
        })

        this.checkboxesReferences = {};
        this.guiasSelecionadas = [];
    }

    handleSort = (clickedColumn, willReverse) => {
        let { column, direction, tableRows, data } = this.state;
        if (column !== clickedColumn) {
            if (clickedColumn === 'nomebeneficiario')
                this.setState({
                    column: clickedColumn,
                    tableRows: this.mapTableRowJSX(_.sortBy(data, ['atendimento.nomebeneficiario'])),
                    direction: 'ascending',
                });
            else if (clickedColumn === 'dataatendimento')
                this.setState({
                    column: clickedColumn,
                    tableRows: this.mapTableRowJSX(_.sortBy(data, ['atendimento.dataatendimento'])),
                    direction: 'ascending',
                });
            else
                this.setState({
                    column: clickedColumn,
                    tableRows: this.mapTableRowJSX(_.sortBy(data, [clickedColumn])),
                    direction: 'ascending',
                });
            return
        }

        if (willReverse === 'dontreverse')
            this.setState({
                direction: 'descending'
            });
        else
            this.setState({
                tableRows: tableRows.reverse(),
                direction: direction === 'ascending' ? 'descending' : 'ascending'
            });
    }

    render() {
        let { column, direction, actualPage, amountPages, tableRows, modalValues } = this.state;

        let dataModal = {};
        if (modalValues) {
            const dataParaQuebrar = new Date(modalValues.data);
            dataModal.dia = dataParaQuebrar.getDate();
            dataModal.dia = dataModal.dia.toString().length == 1 ? `0${dataModal.dia}` : dataModal.dia;
            dataModal.mes = dataParaQuebrar.getMonth()+1;
            dataModal.mes = dataModal.mes.toString().length == 1 ? `0${dataModal.mes}` : dataModal.mes;
            dataModal.ano = dataParaQuebrar.getFullYear();
        }

        const loader = this.state.showLoader ? <AjaxLoader/> : "";

        let excluirModal = (
            <Modal open={this.state.openExcluirModal} className='modal-layout scrolling'>
                <Header content={m.TELA_GERACAO_LOTE_COBRANCA.TITULO_MODAL_REMOVER_COBRANCA} className={"form-header-title"} />
                <Modal.Content>
                    <p className='modal-description-text'>
                        {m.TELA_GERACAO_LOTE_COBRANCA.MENSAGEM_MODAL_REMOVER_COBRANCA}
                    </p>
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        color='red'
                        onClick={() => {
                            this.setState({ openExcluirModal: false });
                        }}
                    >
                        <Icon name='remove' /> {m.TELA_PROFISSIONAIS_EXECUTANTES.MODAL_LABEL_NAO}
                    </Button>
                    <Button
                        color='green'
                        onClick={() => {
                            this.props.deleteCobranca(this.state.idCobrancaToDelete
                                , (result) => {
                                    this.resetGuiasSelecionadas();
                                    this.updateTableRows();
                                    this.props.callSnackbar(m.TELA_GERACAO_LOTE_COBRANCA.MENSAGEM_SUCESSO_EXCLUIR_COBRANCA, 'success');
                                }
                                , (error) => {
                                    this.props.callSnackbar(m.TELA_GERACAO_LOTE_COBRANCA.MENSAGEM_ERROR_EXCLUIR_COBRANCA, 'error');
                                })
                            this.setState({ openExcluirModal: false });
                        }}
                    >
                        <Icon name='checkmark' /> {m.TELA_PROFISSIONAIS_EXECUTANTES.MODAL_LABEL_SIM}
                    </Button>
                </Modal.Actions>
            </Modal>
        );

        let modalPositivo = (
            <CemigModal
                activeAccordion="0"
                modalId='modal-larger'
                isOpened={this.state.openSuccessModal}
                title={m.TELA_GERACAO_LOTE_COBRANCA.TITULO_MODAL_LOTE_SUCESSO}
                ref={el => (this.componentRef = el)}
                content={(
                    <Grid columns='equal' className="margin-modal-lote-sucesso">
                        <Grid.Column>
                            <div>
                                <label className={"label-title-modal"}>{m.TELA_GERACAO_LOTE_COBRANCA.LABEL_NUM_PROTOCOLO_MODAL}</label>
                            </div>
                            <div>
                                <label className={"label-description-modal"}>{modalValues ? modalValues.numeroProtocolo : ''}</label>
                            </div>
                            <div className='div-separador-top-10'>
                                <ReactToPrint
                                    trigger={() => <label id={"label-copiar"}>{m.TELA_GERACAO_LOTE_COBRANCA.LABEL_IMPRIMIR}</label>}
                                    content={() => this.componentRef}
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                            <div>
                                <label className={"label-title-modal"}>{m.TELA_GERACAO_LOTE_COBRANCA.LABEL_NUM_LOTE_MODAL}</label>
                            </div>
                            <div>
                                <label className={"label-description-modal"}>{modalValues ? modalValues.numeroLote : ''}</label>
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                            <div>
                                <label className={"label-title-modal"}>{m.TELA_GERACAO_LOTE_COBRANCA.LABEL_DATA_MODAL}</label>
                            </div>
                            <div>
                                <label className={"label-description-modal"}>{dataModal ? `${dataModal.dia}/${dataModal.mes}/${dataModal.ano}` : ''}</label>
                            </div>
                        </Grid.Column>
                        {/* <Grid.Column>
                            <div>
                                <label className={"label-title-modal"}>{m.TELA_GERACAO_LOTE_COBRANCA.LABEL_VALOR_MODAL}</label>
                            </div>
                            <div>
                                <label className={"label-description-modal"}>{modalValues ? `R$ ${modalValues.valor}` : ''}</label>
                            </div>
                        </Grid.Column> */}
                    </Grid>
                )}
                close={() => {
                    this.setState({ openSuccessModal: false, modalValues: null });
                    this.props.changeModalOpenedStatus();
                    this.resetGuiasSelecionadas();
                    if (this.state.lastRequestWasFiltered)
                        this.updateApplyingFilter(null);
                    else
                        this.updateTableRows();
                }}
            />
        );

        let modalNegativo = (
            <CemigModal
                activeAccordion="0"
                isOpened={this.state.openErrorModal}
                title={m.TELA_GERACAO_LOTE_COBRANCA.TITULO_MODAL_LOTE_FALHA}
                content={(
                    <div>
                        <div>
                            <div>
                                <label className={"label-title-modal"}>{m.TELA_GERACAO_LOTE_COBRANCA.LABEL_COD_ERRO_MODAL}</label>
                            </div>
                            <div>
                                <label className={"label-description-modal"}>{modalValues ? modalValues.codigoGlosa : ''}</label>
                                <CopyToClipboard text={modalValues ? modalValues.codigoGlosa : ''}
                                    style={{ marginLeft: 20 }}
                                    onCopy={() => { this.props.callSnackbar(m.TELA_GERACAO_LOTE_COBRANCA.NOTIFICACAO_CODIGO_GLOSA_COPIADO, 'success') }}>
                                    <label onClick={this.dispatchGuiaSnackbar} id={"label-copiar"}>{m.TELA_GERACAO_LOTE_COBRANCA.LABEL_COPIAR}</label>
                                </CopyToClipboard>
                            </div>
                        </div>
                        <div className='div-separador-top-25'>
                            <div>
                                <label className={"label-title-modal"}>{m.TELA_GERACAO_LOTE_COBRANCA.LABEL_DESCRICAO_MODAL}</label>
                            </div>
                            <div>
                                <label className={"label-description-modal"}>{modalValues ? modalValues.motivoGlosa : ''}</label>
                            </div>
                        </div>
                    </div>
                )}
                close={() => {
                    this.setState({ openErrorModal: false, modalValues: null });
                    this.props.changeModalOpenedStatus();
                    this.resetGuiasSelecionadas();
                    if (this.state.lastRequestWasFiltered)
                        this.updateApplyingFilter(null);
                    else
                        this.updateTableRows();
                }}
            />
        );

        let paginationMenu = (
            <div>
                <div className='layout-pagination-cobranca-div'>
                    <Menu pagination>
                        <Menu.Item as='a' icon
                            onClick={() => {
                                this.setState({ actualPage: actualPage > 1 ? actualPage - 1 : 1 }
                                    , this.state.lastRequestWasFiltered ? this.updateApplyingFilter : this.updateTableRows);
                            }}
                        >
                            <Icon name='chevron left' />
                        </Menu.Item>
                        <Menu.Item>
                            Página {actualPage} de {amountPages}
                        </Menu.Item>
                        <Menu.Item as='a' icon
                            disabled={actualPage === amountPages}
                            onClick={() => {
                                this.setState({ actualPage: actualPage < amountPages ? actualPage + 1 : amountPages }
                                    , this.state.lastRequestWasFiltered ? this.updateApplyingFilter : this.updateTableRows);
                            }}
                        >
                            <Icon name='chevron right' />
                        </Menu.Item>
                    </Menu>
                </div>
            </div>
        );

        let tableHeader = (
            <div className='table-header-footer' style={{ borderBottomWidth: 0, paddingTop: 0, paddingBottom: 0 }}>
            </div>
        );

        let tableFooter = (
            <div className='table-header-footer' style={{ borderTopWidth: 0 }}>
                {paginationMenu}
            </div>
        );

        return (
            <div className='wrapper'>
                {loader}
                {tableHeader}
                <div className='layout-table-cobrancas-body'>
                    <Table striped sortable>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>
                                    <div className='td-cobranca-checkbox'>
                                        <Checkbox
                                            title={m.TELA_GERACAO_LOTE_COBRANCA.TITULO_CHECKBOX_SELECIONAR_TODOS}
                                            className='custom-header-checkbox'
                                            checked={this.state.checkAll}
                                            onClick={() => {
                                                let checkAll = !this.state.checkAll;

                                                // Deverá buscar todos os checkbox com o início do nome do id definido
                                                var todasGuias = document.querySelectorAll('input[id*=check]');
                                                (todasGuias ?? []).forEach(guia => {
                                                    this.checkboxesReferences[guia.id].state.checked = checkAll;
                                                    guia.checked = checkAll;
                                                });

                                                this.guiasSelecionadas = checkAll
                                                    ? this.state.data
                                                    : [];

                                                this.setState({
                                                    checkAll: checkAll,
                                                    amountGuiasSelecionadas: (this.guiasSelecionadas ?? []).length
                                                });
                                            }}
                                        />
                                    </div>
                                </Table.HeaderCell>
                                <Table.HeaderCell
                                    sorted={column === 'numeroGuiaPrestador' ? direction : null}
                                    onClick={() => { this.handleSort('numeroGuiaPrestador') }} >
                                    {m.TELA_GERACAO_LOTE_COBRANCA.LABEL_TABLE_NUMERO_GUIA}
                                </Table.HeaderCell>
                                <Table.HeaderCell
                                    sorted={column === 'numeroCarteira' ? direction : null}
                                    onClick={() => { this.handleSort('numeroCarteira') }}>
                                    {m.TELA_GERACAO_LOTE_COBRANCA.LABEL_TABLE_NUMERO_CARTEIRA}
                                </Table.HeaderCell>
                                <Table.HeaderCell
                                    sorted={column === 'nomebeneficiario' ? direction : null}
                                    onClick={() => { this.handleSort('nomebeneficiario') }}>
                                    {m.TELA_GERACAO_LOTE_COBRANCA.LABEL_TABLE_BENEFICIARIO}
                                </Table.HeaderCell>
                                <Table.HeaderCell
                                    sorted={column === 'dataatendimento' ? direction : null}
                                    onClick={() => { this.handleSort('dataatendimento') }}>
                                    {m.TELA_GERACAO_LOTE_COBRANCA.LABEL_TABLE_DATA_ATENDIMENTO}
                                </Table.HeaderCell>
                                <Table.HeaderCell
                                    sorted={column === 'caraterAtendimento' ? direction : null}
                                    onClick={() => { this.handleSort('caraterAtendimento') }}>
                                    {m.TELA_GERACAO_LOTE_COBRANCA.LABEL_TABLE_TIPO_ATENDIMENTO}
                                </Table.HeaderCell>
                                <Table.HeaderCell className='td-cobranca-center-align'>
                                    {m.TELA_GERACAO_LOTE_COBRANCA.LABEL_TABLE_APAGAR}
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {tableRows}
                        </Table.Body>
                    </Table>
                </div>
                {tableFooter}
                <div className='div-separador-50' />
                <div className='div-separador-10' />
                <div className='div-gerar-lote'>
                    <Button
                        disabled={this.guiasSelecionadas.length < 1}
                        className='button-enviar-lote'
                        onClick={this.enviarLote}
                    >
                        {m.TELA_GERACAO_LOTE_COBRANCA.LABEL_ENVIAR_LOTE}
                    </Button>
                    <span className='guias-selecionadas-box'>
                        <span id='guias-selecionadas-bold'>
                            {this.guiasSelecionadas.length}
                        </span>
                        <span id='guias-selecionadas'>
                            {m.TELA_GERACAO_LOTE_COBRANCA.LABEL_GUIAS_SELECIONADAS}
                        </span>
                    </span>
                </div>
                {excluirModal}
                {modalPositivo}
                {modalNegativo}
            </div>
        );
    }
}

export default connect(null, { getAllCobrancas, getAllFilteredCobrancas, postLote, deleteCobranca })(TableCobrancas);
